// Theme Presets

const lightTheme = {
  name: "light",
  body: "#edf3fa",
  text: "#102038",
  dark: "#061329",
  secondaryText: "#516987",
  accentColor: "#0f7bff",
  accentBright: "#0994ff",
  projectCard: "#ffffff",
  skinColor: "#f7b799",
  skinColor2: "#fcb696",
  imageDark: "#dce7f5",
  imageClothes: "#eef4ff",
  avatarMisc: "#dde7f4",
  avatarShoes: "#cbd7e8",
  surface: "rgba(255, 255, 255, 0.82)",
  surfaceStrong: "#ffffff",
  borderColor: "rgba(16, 32, 56, 0.12)",
  shadowColor: "rgba(13, 39, 77, 0.18)",
  glowColor: "rgba(15, 123, 255, 0.2)",
};

const darkTheme = {
  name: "dark",
  body: "#081427",
  text: "#eaf2ff",
  dark: "#030812",
  secondaryText: "#9bb1d2",
  accentColor: "#22c7e7",
  accentBright: "#05b2d0",
  projectCard: "#0f2038",
  skinColor: "#f7b799",
  skinColor2: "#fcb696",
  imageDark: "#0f2038",
  imageClothes: "#061123",
  avatarMisc: "#0a1a30",
  avatarShoes: "#081123",
  surface: "rgba(9, 24, 44, 0.74)",
  surfaceStrong: "#0c1b31",
  borderColor: "rgba(173, 216, 255, 0.14)",
  shadowColor: "rgba(1, 8, 18, 0.44)",
  glowColor: "rgba(34, 199, 231, 0.28)",
};

export const themes = { light: lightTheme, dark: darkTheme };
